export function activateLinkEditor(state, dispatch, view) {
   const markType = state.schema.marks.link;
   const pluginKey = view.props.linkEditorKey;
   const plugin = state.config.pluginsByKey[pluginKey];
   const { empty, $cursor, $from, $to } = state.selection;
   let tr = state.tr;

   // if no text is selected and the mark is not applied, do nothing
   if (empty && !markType.isInSet($cursor.marks())) {
      return true;
   }

   const pluginState = plugin.getState(state);

   if (pluginState.state === 'visible') {
      plugin.props.hideEditingBubble(view);
      view.focus();
      return true;
   }

   if (!markActive(state, markType)) {
      tr.addMark($from.pos, $to.pos, markType.create({ href: '' }));
      view.dispatch(tr);
      state = state.apply(tr);
   }

   // When creating a new link mark, automatically place and focus the
   // editing bubble above the first new link.
   const nodeAfter = state.selection.$from.nodeAfter;

   let pos = state.selection.$from.pos;
   if (nodeAfter) {
      pos += Math.floor(nodeAfter.nodeSize / 2);
   }

   plugin.props.showEditingBubble(view, pos);
   plugin.props.focusEditingBubble(view);

   return true;
}

export function activateMediaManager(state, dispatch, view) {
   document.activeElement.blur();
   const target = new MinimalMediaTarget({
      customAttach: function(mediaItem, finished) {
         if (mediaItem) {
            const tr = state.tr.insertText(mediaItem.toWikiText());
            view.dispatch(tr);
            view.focus();
         }
         // Finished expects the old media item in the case of mutation
         // and a success boolean.
         finished(null, true);
      },
      accepts: 'wiki_media',
   });

   window.MediaManager.browse(target);

   return true;
}

function markActive(state, type) {
   let { from, $from, to, empty } = state.selection;
   if (empty) {
      return type.isInSet($from.marks());
   } else {
      return state.doc.rangeHasMark(from, to, type);
   }
}
